/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import anime from 'animejs/lib/anime.es.js';

import { 
  CircularProgress, 
  Skeleton 
} from '@mui/material';

import { 
  GetConversionRates 
} from '../../redux/actions/conversionRates';

import "./styles.scss";

const HomePage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState();

  // currency conversion
  const [selectedCurrency, setSelectedCurrency] = useState('EUR');
  const [usdAmount, setUsdAmount] = useState();
  const [convertedAmount, setConvertedAmount] = useState();
  const [initialRate, setInitialRate] = useState(0); 
  const [fixedSide, setFixedSide] = useState("sell");

  const [conversionError, setConversionError] = useState("");

  const [rateFetching, setRateFetching] = useState(false);
  const [initialRateFetching, setInitialRateFetching] = useState(true);

  useEffect(() => {
    if(location.hash) handleScrollToView(location.hash.slice(1))
  }, [location]);

  // ------------------ miscellaneous -------------------
  const handleScrollToView = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  } 

	useEffect(() => {
		var timeLine1 = anime.timeline({
			easing: 'easeOutExpo',
			loop: true
		});

		timeLine1
		.add({
			targets: "#text1",
			keyframes: [
				{ height: "60px", duration: 200 },
				{ height: "0px", duration: 200, delay: 2000 },
			]
		})
		.add({
			targets: "#text2",
			keyframes: [
				{ height: "60px", duration: 200 },
				{ height: "0px", duration: 200, delay: 2000 },
			]
		})
		.add({
			targets: "#text3",
			keyframes: [
				{ height: "60px", duration: 200 },
				{ height: "0px", duration: 200, delay: 2000 },
			]
		})
		.add({
			targets: "#text4",
			keyframes: [
				{ height: "60px", duration: 200 },
				{ height: "0px", duration: 200, delay: 2000 },
			]
		})
		.add({
			targets: "#text5",
			keyframes: [
				{ height: "60px", duration: 200 },
				{ height: "0px", duration: 200, delay: 2000 },
			]
		})

	}, []);


  function handleGetConversionRates(currency, base_currency, amount) {
    if(amount && amount.length > 0){
      let query = "";
      query += `&buy_currency=${currency}`;
      query += `&sell_currency=${base_currency}`;
      query += `&fixed_side=${fixedSide}`;
      query += `&amount=${amount.replace(/[^0-9.]/g, '')}`;
      query += `&conversion_date_preference=earliest`;
      query += `&product=pay`;
      dispatch(GetConversionRates(query, setRateFetching)).then(({ res, statusCode }) => {
        console.log(res, statusCode)
        if(statusCode === 200){
          if(fixedSide === "sell"){
            setConvertedAmount(formatNumber(res.data.clientBuyAmount+""));
            setInitialRate(parseFloat(res.data.clientBuyAmount/(usdAmount.replace(/[^0-9.]/g, ''))).toFixed(4));
          } else {
            setUsdAmount(formatNumber(res.data.clientSellAmount+""));  
            setInitialRate(parseFloat((convertedAmount.replace(/[^0-9.]/g, '')/res.data.clientSellAmount)).toFixed(4));
          }
          setConversionError("");
        } else {
          console.log("Asdf")
          setConversionError("The FOREX market is closed for the weekend/holiday. Please check back on the next business day when trading reopens.");
          setConvertedAmount('');
          setUsdAmount('');
          setInitialRate(0);
        };
      }); 
    } else {
      setRateFetching(false);
    }
  };

  function handleGetInitialRates(currency, base_currency, fixed_side="sell") {
    let query = "";
    query += `&buy_currency=${currency}`;
    query += `&sell_currency=${base_currency}`;
    query += `&fixed_side=${fixed_side}`;
    query += `&amount=1`;
    query += `&conversion_date_preference=earliest`;
    query += `&product=pay`;
    dispatch(GetConversionRates(query, setInitialRateFetching)).then(({ res, statusCode }) => {
      if(statusCode === 200){
        setInitialRate(parseFloat(res.data.clientBuyAmount).toFixed(4));
        setConversionError("");
      } else {
        setConversionError("The FOREX market is closed for the weekend/holiday. Please check back on the next business day when trading reopens.");
      };
    }); 
  };


  const currencyData = {
    EUR: {symbol: "€", flag: "https://flagcdn.com/eu.svg"},
    AUD: {symbol: "A$", flag: "https://flagcdn.com/au.svg"},
    BHD: {symbol: "ب.د", flag: "https://flagcdn.com/bh.svg"},
    CAD: {symbol: "C$", flag: "https://flagcdn.com/ca.svg"},
    CNY: {symbol: "¥", flag: "https://flagcdn.com/cn.svg"},
    CZK: {symbol: "Kč", flag: "https://flagcdn.com/cz.svg"},
    DKK: {symbol: "kr", flag: "https://flagcdn.com/dk.svg"},
    HKD: {symbol: "HK$", flag: "https://flagcdn.com/hk.svg"},
    HUF: {symbol: "Ft", flag: "https://flagcdn.com/hu.svg"},
    INR: {symbol: "₹", flag: "https://flagcdn.com/in.svg"},
    IDR: {symbol: "Rp", flag: "https://flagcdn.com/id.svg"},
    ILS: {symbol: "₪", flag: "https://flagcdn.com/il.svg"},
    JPY: {symbol: "¥", flag: "https://flagcdn.com/jp.svg"},
    KES: {symbol: "KSh", flag: "https://flagcdn.com/ke.svg"},
    KWD: {symbol: "د.ك", flag: "https://flagcdn.com/kw.svg"},
    MYR: {symbol: "RM", flag: "https://flagcdn.com/my.svg"},
    MXN: {symbol: "Mex$", flag: "https://flagcdn.com/mx.svg"},
    NZD: {symbol: "NZ$", flag: "https://flagcdn.com/nz.svg"},
    NOK: {symbol: "kr", flag: "https://flagcdn.com/no.svg"},
    OMR: {symbol: "ر.ع.", flag: "https://flagcdn.com/om.svg"},
    PHP: {symbol: "₱", flag: "https://flagcdn.com/ph.svg"},
    PLN: {symbol: "zł", flag: "https://flagcdn.com/pl.svg"},
    QAR: {symbol: "ر.ق", flag: "https://flagcdn.com/qa.svg"},
    RON: {symbol: "lei", flag: "https://flagcdn.com/ro.svg"},
    SAR: {symbol: "ر.س", flag: "https://flagcdn.com/sa.svg"},
    SGD: {symbol: "S$", flag: "https://flagcdn.com/sg.svg"},
    ZAR: {symbol: "R", flag: "https://flagcdn.com/za.svg"},
    SEK: {symbol: "kr", flag: "https://flagcdn.com/se.svg"},
    CHF: {symbol: "Fr", flag: "https://flagcdn.com/ch.svg"},
    THB: {symbol: "฿", flag: "https://flagcdn.com/th.svg"},
    TRY: {symbol: "₺", flag: "https://flagcdn.com/tr.svg"},
    UGX: {symbol: "USh", flag: "https://flagcdn.com/ug.svg"},
    GBP: {symbol: "£", flag: "https://flagcdn.com/gb.svg"},
    AED: {symbol: "د.إ", flag: "https://flagcdn.com/ae.svg"}
  };

  const rates = {
    EUR: 0.8698, AUD: 1.48, BHD: 0.377, CAD: 1.36, CNY: 7.23, CZK: 22.6, DKK: 6.85,
    HKD: 7.83, HUF: 348, INR: 83.2, IDR: 16200, ILS: 3.65, JPY: 156.2, KES: 131.2,
    KWD: 0.307, MYR: 4.7, MXN: 16.8, NZD: 1.62, NOK: 10.7, OMR: 0.385, PHP: 57.2,
    PLN: 4.05, QAR: 3.64, RON: 4.32, SAR: 3.75, SGD: 1.35, ZAR: 18.1, SEK: 10.5,
    CHF: 0.91, THB: 36.1, TRY: 32.5, UGX: 3840, GBP: 0.79, AED: 3.67
  };

  const handleCurrencyChange = (event) => {
    const code = event.target.value;
    setSelectedCurrency(code);
    setConvertedAmount(''); // Reset converted amount
  };

  const handleConversion = (e) => {
    e.preventDefault();
    console.log("asdf", usdAmount)
    handleGetConversionRates(selectedCurrency, 'USD', fixedSide === "sell" ? usdAmount : convertedAmount);


    // const rate = rates[selectedCurrency];
    // const usd = parseFloat(usdAmount) || 0;
    // if (usd > 0 && rate > 0) {
    //   const converted = usd * rate;
    //   setConvertedAmount(converted.toLocaleString(undefined, {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2
    //   }));
    // }
  };


  useEffect(() => {
    handleGetInitialRates(selectedCurrency, 'USD');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrency]);

  const formatNumber = (value) => {
    // Remove all non-numeric characters except decimal point
    const cleanValue = value.replace(/[^\d.]/g, '');
    
    // Ensure only one decimal point
    const parts = cleanValue.split('.');
    if (parts.length > 2) return parts[0] + '.' + parts.slice(1).join('');
    
    // Format with commas and 2 decimal places
    const num = parseFloat(cleanValue);
    if (isNaN(num)) return '';
    
    if (cleanValue.includes('.')) {
      const [integer, decimal] = cleanValue.split('.');
      return integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + decimal.slice(0, 2);
    }
    
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // Initialize slider and attach dot listeners from React lifecycle
  useEffect(() => {
    const slides = document.querySelectorAll('.hero-slide');
    const dots = document.querySelectorAll('.dot');
    if (!slides || slides.length === 0) return; // nothing to do

    let currentSlide = Array.from(slides).findIndex(s => s.classList.contains('active'));
    if (currentSlide === -1) currentSlide = 0;
    const intervalTime = 6000;

    const showSlide = (index) => {
      slides[currentSlide]?.classList.remove('active');
      dots[currentSlide]?.classList.remove('active');
      currentSlide = (index + slides.length) % slides.length;
      slides[currentSlide]?.classList.add('active');
      dots[currentSlide]?.classList.add('active');
    };

    const nextSlide = () => showSlide(currentSlide + 1);

    let slideInterval = setInterval(nextSlide, intervalTime);

    const dot1 = document.getElementById('dot_1');
    const dot2 = document.getElementById('dot_2');

    const onDot1 = () => {
      clearInterval(slideInterval);
      showSlide(0);
      slideInterval = setInterval(nextSlide, intervalTime);
    };

    const onDot2 = () => {
      clearInterval(slideInterval);
      showSlide(1);
      slideInterval = setInterval(nextSlide, intervalTime);
    };

    dot1?.addEventListener('click', onDot1);
    dot2?.addEventListener('click', onDot2);

    return () => {
      clearInterval(slideInterval);
      dot1?.removeEventListener('click', onDot1);
      dot2?.removeEventListener('click', onDot2);
    };
  }, []);


  return (
    <>
	  <div dangerouslySetInnerHTML={{ __html: `
      <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>LUSIDPAY | AI-Driven Payments & Accounting</title>
  <link href="https://fonts.googleapis.com/css2?family='Plus Jakarta Sans':wght@400;600;800&display=swap" rel="stylesheet">
  <style>
    :root {
      --blue-main: #253f83;
      --blue-btn-hover: #0d67e3;
      --blue-dark: #004182;
      --blue-muted: #56687a;
      --blue-light: #dce6f1;
      --grey-main: #38434f;
      --grey-light: #e9e5df;
      --off-white: #fdfaf5;
      --white: #ffffff;

      /* User Defined Palette */
      --brand-imperial: #004182; /* Main Brand Color */
      --brand-dark: #00274F;     /* Deep Navy */
      --brand-bright: #253f83;   /* Highlight Blue */
      --btn-action: #253f83;     /* Action Buttons */
      
      /* Neutrals */
      --text-main: #1e293b;
      --text-light: #475569;
      --bg-light: #f8fafc;
      --white: #ffffff;
      
      /* Spacing */
      --container-width: 1200px;
    }
    html, body {
      margin: 0;
      padding: 0;
      background: var(--white);
      color: var(--grey-main);
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
      // font-size: 18px;
      line-height: 1.6;
    }

    /* --- TYPOGRAPHY --- */
    h1, h2, h3 {
        font-weight: 800;
        line-height: 1.2;
        color: var(--brand-dark);
    }

    h1 { font-size: 3.5rem; letter-spacing: -1px; }
    h2 { font-size: 2.5rem; margin-bottom: 1rem; }
    h3 { font-size: 1.25rem; margin-bottom: 0.5rem; }

    header {
      width: 100%;
      background: var(--white);
      position: sticky;
      top: 0;
      z-index: 100;
      border-bottom: 1px solid var(--grey-light);
    }
    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 32px;
    }
    .logo img {
      height: 40px;
      display: block;
    }
    nav {
      display: flex;
      gap: 32px;
      align-items: center;
    }
    nav a {
      text-decoration: none;
      color: var(--grey-main);
      font-weight: 500;
      font-size: 1rem;
      padding: 6px 0;
      transition: color 0.15s;
    }
    nav a:hover {
      color: var(--blue-main);
    }
    .cta-nav {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 6px;
      padding: 8px 22px;
      font-weight: 600;
      font-size: 1rem;
      margin-left: 12px;
      text-decoration: none;
      transition: background 0.15s;
      border: none;
      cursor: pointer;
    }
    .cta-nav:hover {
      background: var(--blue-dark);
    }

    .btn {
      display: inline-block;
      padding: 12px 28px;
      border-radius: 10px;
      font-weight: 600;
      font-size: 1rem;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .btn-primary {
      background-color: var(--btn-action);
      color: var(--white);
      border: 1px solid var(--btn-action);
    }

    .btn-primary:hover {
      background-color: var(--brand-bright);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(10, 102, 194, 0.3);
    }
    
  /* --- LAYOUT UTILS --- */
    .container {
      max-width: var(--container-width);
      margin: 0 auto;
      padding: 0 20px;
    }

    .section-padding { padding: 80px 0; }


  /* --- HERO SLIDER STYLES --- */
    .hero {
      background: linear-gradient(135deg, var(--brand-dark) 0%, var(--brand-imperial) 100%);
      color: var(--white);
      position: relative;
      overflow: hidden;
      height: 680px; /* Fixed height to prevent jumping content */
      display: flex;
      align-items: center;
    }

    .hero::before {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-image: 
          linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px);
      background-size: 40px 40px;
      opacity: 0.3;
      z-index: 1;
    }

    /* Slide Container */
    .hero-slide {
      position: absolute;
      top: 0; left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.8s ease-in-out, visibility 0.8s;
      display: flex;
      align-items: center; /* Vertically center content */
      z-index: 2;
    }

    .hero-slide.active {
      opacity: 1;
      visibility: visible;
    }

    .hero-content {
      position: relative;
      max-width: 900px;
      width: 100%;
      margin: auto;
    }

    .hero h1 { color: var(--white); margin-bottom: 24px; }
    .hero p { 
      color: rgba(255,255,255,0.9); 
      font-size: 1.25rem; 
      margin-bottom: 40px; 
      max-width: 750px;
    }

    /* Trust Badge Styling for Slide 2 */
    .trust-badge {
      margin-top: 20px;
      background: rgba(255,255,255,0.1);
      padding: 15px 20px;
      border-radius: 8px;
      border-left: 4px solid var(--btn-action);
      font-size: 0.95rem;
      color: rgba(255,255,255,0.95);
      display: inline-block;
    }

    .hero-badges {
      margin-top: 40px;
      display: flex;
      gap: 20px;
      font-size: 0.85rem;
      opacity: 0.7;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 700;
    }

    /* Slider Controls (Optional visual indicators) */
    .slider-dots {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 10px;
      z-index: 10;
    }

    .dot {
      width: 10px;
      height: 10px;
      background: rgba(255,255,255,0.3);
      border-radius: 50%;
      cursor: pointer;
    }

    .dot.active { background: var(--white); }

    /* --- FEATURE PILLARS --- */
    .features { background: var(--bg-light); }
    
    .section-header {
      text-align: center;
      max-width: 700px;
      margin: 0 auto 60px auto;
    }

    .grid-3 {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 30px;
    }

    .card {
      background: var(--white);
      padding: 40px 30px;
      border-radius: 12px;
      border: 1px solid #e2e8f0;
      transition: transform 0.3s ease;
    }

    .card:hover {
      transform: translateY(-5px);
      border-color: var(--btn-action);
      box-shadow: 0 10px 30px rgba(0,0,0,0.05);
    }

    .icon-box {
      width: 50px;
      height: 50px;
      background: rgba(10, 102, 194, 0.1);
      color: var(--btn-action);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5rem;
      margin-bottom: 20px;
      font-weight: bold;
    }

    .card-tag {
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      color: var(--brand-bright);
      margin-bottom: 10px;
      display: block;
    }

    .section {
      max-width: 1100px;
      margin: 0 auto 60px auto;
      padding: 0 24px;
    }
    .section-title {
      font-size: 2rem;
      font-weight: 700;
      color: var(--blue-main);
      text-align: center;
      margin-bottom: 36px;
      letter-spacing: -0.5px;
    }
    .feature-block {
      flex: 1 1 280px;
      background: transparent;
      border-radius: 0;
      padding: 0 0 0 0;
      margin-bottom: 24px;
      text-align: left;
      min-width: 260px;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      gap: 18px;
    }
    .feature-block .icon {
      font-size: 2.1em;
      color: var(--blue-main);
      flex-shrink: 0;
      margin-top: 2px;
      transition: transform 0.18s;
    }
    .feature-block:hover .icon {
      transform: scale(1.15);
    }
    .feature-block h3 {
      font-size: 1.35rem;
      font-weight: 700;
      color: var(--blue-main);
      margin-bottom: 12px;
      letter-spacing: 0;
      margin-top: 0;
    }
    .feature-block p {
      font-size: 1.12rem;
      color: var(--grey-main);
      margin-bottom: 0;
      font-weight: 400;
      opacity: 0.95;
      margin-top: 0;
    }
    .manage-cash-section {
      background: var(--off-white);
      padding: 80px 0 60px 0;
      margin-bottom: 40px;
    }
    .manage-cash-section .section-title {
      color: var(--grey-main);
    }
    .cash-features-row {
      display: flex;
      justify-content: center;
      gap: 48px;
      flex-wrap: wrap;
      margin-top: 40px;
    }
    #features .features-row {
      display: flex;
      justify-content: space-between;
      gap: 48px;
      flex-wrap: wrap;
    }
    #features .feature-block {
      flex: 1 1 30%;
      min-width: 260px;
      box-sizing: border-box;
    }

    .cash-feature {
      background: var(--white);
      border: none;
      border-radius: 24px;
      width: 370px;
      padding: 48px 38px;
      margin-bottom: 20px;
      text-align: left;
      color: var(--grey-main);
      font-weight: 400;
      min-width: 260px;
      transition: transform 0.18s, box-shadow 0.18s;
      box-shadow: none;
      position: relative;
    }
    .cash-feature .icon {
      font-size: 2em;
      color: var(--blue-main);
      position: absolute;
      right: 28px;
      top: 38px;
      opacity: 0.53;
      pointer-events: none;
    }
    .cash-feature:hover {
      transform: translateY(-4px) scale(1.02);
      box-shadow: 0 4px 32px rgba(10,102,194,0.08);
    }
    .cash-feature h3 {
      color: var(--blue-main);
      margin-bottom: 18px;
      font-size: 1.28em;
      font-weight: 700;
    }
    .cash-feature p {
      font-size: 1.07em;
      margin-bottom: 18px;
      color: var(--grey-main);
      opacity: 0.92;
    }
    .cash-feature ul {
      padding-left: 18px;
      margin-bottom: 18px;
    }
    .cash-feature ul li {
      margin-bottom: 8px;
      color: var(--blue-main);
      font-weight: 500;
      font-size: 1.07em;
    }
    .cash-feature .learn-more {
      color: var(--blue-main);
      font-weight: bold;
      text-decoration: none;
      transition: color 0.15s;
      font-size: 1.07em;
    }
    .cash-feature .learn-more:hover {
      color: var(--blue-dark);
    }
    /* International Payments Section */
    .international-section {
      position: relative;
      padding: 10px 0 40px 0;
      background: linear-gradient(120deg, #dce6f1 0%, #fbbd0415 100%);
      overflow: hidden;
    }
    .international-bg {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background: url('https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=800&q=80') center/cover no-repeat;
      opacity: 0.06;
      z-index: 1;
    }
    .international-content {
      position: relative;
      z-index: 2;
      max-width: 1100px;
      margin: 0 auto;
      padding: 0 24px;
      text-align: center;
    }
    .international-title {
      font-size: 2.3rem;
      font-weight: 800;
      color: #253f83;
      margin-bottom: 18px;
      letter-spacing: -1px;
    }
    .international-subtitle {
      font-size: 1.18rem;
      color: #38434f;
      margin-bottom: 44px;
      max-width: 680px;
      margin-left: auto;
      margin-right: auto;
    }
    /* Exchange Rate Calculator Horizontal */
    .exchange-calc-container-horizontal {
      background: #fff;
      border-radius: 24px;
      box-shadow: 0 2px 24px rgba(10,102,194,0.10);
      padding: 32px 28px 28px 28px;
      max-width: 700px;
      width: 100%;
      margin: 0 auto 44px auto;
    }
    .exchange-calc-form-horizontal {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
    .exchange-calc-flex {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      gap: 28px;
    }
    .exchange-calc-block-horizontal {
      flex: 1 1 45%;
      background: #f8fafc;
      border-radius: 14px;
      padding: 20px 18px 16px 18px;
      box-shadow: 0 1px 8px rgba(10,102,194,0.04);
      min-width: 180px;
      max-width: 260px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .exchange-calc-flag {
      margin-bottom: -4px;
      margin-left: 30px;
      min-height: 20px;
    }
    .exchange-calc-label {
      font-size: 1em;
      font-weight: 600;
      color: #253f83;
      margin-bottom: 6px;
      text-align: center;
    }
    .exchange-calc-symbol-input {
      display: flex;
      align-items: center;
      width: 100%;
    }
    .exchange-calc-currency {
      font-size: 1.25em;
      color: #253f83;
      font-weight: 800;
      margin-right: 6px;
    }
    .exchange-calc-input-horizontal {
      width: 160px;
      padding: 12px px 12px px;
      font-size: 1.25em;
      font-weight: 700;
      border: 1.5px solid #dce6f1;
      border-radius: 8px;
      background: #fff;
      color: #38434f;
      outline: none;
      text-align: right;
    }
    .exchange-calc-currency-label {
      margin-top: 5px;
      font-size: 0.98em;
      color: #56687a;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
    .exchange-calc-arrow-horizontal {
      font-size: 2.4em;
      color: #253f83;
      font-weight: bold;
      margin: 0 10px 14px 10px;
      align-self: flex-end;
    }
    .exchange-calc-rate-row-horizontal {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 14px;
      gap: 10px;
    }
    .exchange-calc-rate {
      font-size: 1em;
      color: #38434f;
      font-weight: 500;
    }
    .exchange-calc-btn-horizontal {
      background: #253f83;
      color: #fff;
      border: none;
      border-radius: 20px;
      padding: 10px 26px;
      font-size: 1.08em;
      font-weight: 700;
      cursor: pointer;
      transition: background 0.15s;
    }
    .exchange-calc-btn-horizontal:hover {
      background: #004182;
    }
    .exchange-calc-note {
      margin-top: 10px;
      font-size: 0.69em;
      color: #56687a;
      text-align: left;
    }

    #trust {
      padding-top: 60px;
    }

    .trust-row {
      display: flex;
      justify-content: center;
      gap: 32px;
      margin-top: 40px;
      margin-bottom: 10px;
      flex-wrap: wrap;
    }
    .trust-block {
      background: var(--blue-light);
      border-radius: 14px;
      padding: 26px 18px;
      min-width: 220px;
      text-align: center;
      font-size: 1.07em;
      color: var(--blue-dark);
      flex: 1 1 220px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
    }
    .security-note {
      text-align: center;
      color: var(--grey-main);
      margin-top: 12px;
      font-size: 1em;
    }
    .industry-desc {
      text-align: center;
      color: var(--grey-main);
      font-size: 1.05em;
      margin-bottom: 36px;
    }
    .how-works-row {
      display: flex;
      justify-content: center;
      gap: 32px;
      flex-wrap: wrap;
      margin-top: 40px;
      margin-bottom: 10px;
    }
    .how-step {
      background: var(--blue-light);
      border-radius: 14px;
      padding: 30px 18px;
      min-width: 220px;
      text-align: center;
      font-size: 1.07em;
      color: var(--blue-dark);
      flex: 1 1 220px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
    }
    .how-step h4 {
      color: var(--blue-main);
      margin-bottom: 10px;
      font-size: 1.12em;
      font-weight: 700;
    }
    .testimonials-section {
      padding: 60px 0 60px 0;
      background: var(--off-white);
      text-align: center;
    }
    .testimonials-section h2 {
      color: var(--blue-main);
    }
    .testimonial-block {
      max-width: 700px;
      margin: 32px auto 0 auto;
      background: var(--white);
      border-left: 5px solid var(--blue-main);
      padding: 36px 38px;
      font-size: 1.13em;
      color: var(--grey-main);
      font-style: italic;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      text-align: left;
      margin-bottom: 24px;
    }
    .testimonial-author {
      display: block;
      margin-top: 16px;
      font-weight: 700;
      color: var(--blue-main);
      font-style: normal;
    }
     .cta-section {
      background: var(--white);
      text-align: center;
      padding: 50px 0 70px 0;
    }
    .cta-section h2 {
      color: var(--blue-main);
      font-size: 2rem;
      margin-bottom: 18px;
      font-weight: 700;
    }
    .cta-section .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 10px;
      padding: 16px 46px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .cta-section .cta-main:hover {
      background: var(--blue-btn-hover);
    }
    .cta-section .cta-secondary {
      background: var(--white);
      color: var(--blue-main);
      border: 2px solid var(--blue-main);
      border-radius: 24px;
      padding: 14px 40px;
      font-size: 1.1rem;
      font-weight: 700;
      margin: 0 10px;
      cursor: pointer;
      transition: background 0.15s, color 0.15s;
    }
    .cta-section .cta-secondary:hover {
      background: var(--blue-main);
      color: var(--white);
    }

    .industry-tabs-row {
      display: flex;
      justify-content: center;
      gap: 18px;
      margin-bottom: 22px;
      flex-wrap: wrap;
    }
    .industry-tab {
      background: var(--blue-light);
      color: var(--blue-main);
      border-radius: 16px;
      padding: 12px 26px;
      font-weight: 600;
      font-size: 1em;
      border: none;
      cursor: pointer;
      transition: background 0.15s, color 0.15s;
      margin-bottom: 8px;
    }
    .industry-tab.active,
    .industry-tab:hover {
      background: var(--blue-main);
      color: var(--white);
    }
    .international-steps {
      display: flex;
      justify-content: center;
      gap: 38px;
      margin-bottom: 40px;
      flex-wrap: wrap;
    }
    .international-step {
      background: #fff;
      border-radius: 18px;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
      padding: 38px 28px 32px 28px;
      min-width: 220px;
      max-width: 300px;
      flex: 1 1 220px;
      text-align: center;
      margin-bottom: 18px;
    }
    .international-icon {
      width: 62px;
      height: 62px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 18px auto;
      font-size: 2.2rem;
    }
    .international-step-title {
      font-size: 1.08rem;
      font-weight: 700;
      color: #253f83;
      margin-bottom: 8px;
    }
    .international-step-desc {
      font-size: 1em;
      color: #38434f;
    }
    .international-benefits {
      display: flex;
      justify-content: center;
      gap: 30px;
      flex-wrap: wrap;
      margin: 36px 0 28px 0;
    }
    .international-benefit {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #fff;
      border-radius: 16px;
      padding: 16px 28px;
      font-size: 1.08em;
      color: #004182;
      font-weight: 600;
      box-shadow: 0 2px 12px rgba(10,102,194,0.04);
      margin-bottom: 10px;
    }
    .benefit-icon {
      font-size: 1.4em;
      border-radius: 50%;
      padding: 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .international-cta {
      margin-top: 18px;
    }
    @media (max-width: 700px) {
      .features-row, .cash-features-row {
        flex-direction: column;
        align-items: center;
      }
      .feature-block, .cash-feature {
        width: 95%;
        min-width: 180px;
      }
      .nav-container {
        flex-direction: column;
        gap: 16px;
        padding: 12px 8px;
      }
      .exchange-calc-flex {
        flex-direction: column;
        gap: 0;
      }
      .exchange-calc-arrow-horizontal {
        transform: rotate(90deg);
        margin: 10px 0 10px 0;
        align-self: center;
      }
      .exchange-calc-block-horizontal {
        width: 100%;
        max-width: 100%;
        margin-bottom: 8px;
      }
      .exchange-calc-container-horizontal {
        padding: 18px 2vw 18px 2vw;
        max-width: 98vw;
      }
      .international-steps, .international-benefits {
        flex-direction: column;
        align-items: center;
        gap: 22px;
      }
      .international-step, .international-benefit {
        max-width: 95%;
      }
        /* --- RESPONSIVE --- */
      @media (max-width: 768px) {
          h1 { font-size: 2.2rem; }
          .hero { height: auto; min-height: 700px; padding: 100px 0; } /* Auto height on mobile */
      }
    }
  </style>
</head>
<body>

  <!-- ...[head and header remain unchanged]... -->


    <section class="hero">
      <div class="hero-slide active" id="slide-1">
          <div class="container">
              <div class="hero-content">
                  <h1>The Financial Operating System for Construction & Global Trade.</h1>
                  <p>
                      Unify financial workflows across the physical economy. From Government Contractors to Freight Forwarders and Global Importers — synchronize AR/AP automation, compliance data, and cross-border capital in one infrastructure.
                  </p>
                  <div class="hero-badges">
                      <span>Govt. Construction</span> &bull; 
                      <span>Global Supply Chain</span> &bull; 
                      <span>Freight Forwarders</span>
                  </div>

                  <div style="display: flex; gap: 15px; margin-top: 40px; margin-bottom: 40px;">
                      <a href="/contact-us" class="btn btn-primary" style="background: white; color: var(--brand-imperial); border: none; text-decoration: none;">Request Platform Demo</a>
                  </div>

              </div>
          </div>
      </div>

      <div class="hero-slide" id="slide-2">
          <div class="container">
              <div class="hero-content">
                  <h1>The Fast Lane for QuickBooks Desktop.</h1>
                  <p style="margin-bottom: 30px;">
                      Stop waiting 4 days for payments. Deliver Next Day ACH for the standard price. Unlimited Users. Free Accounting Sync. Funds secured at U.S. Bank.
                  </p>
                  
                  <div class="trust-badge" style="margin-bottom: 30px;">
                      ✅ Works seamlessly with <strong>QuickBooks Pro/Premier/Enterprise 2015-2024, and QuickBooks Online.</strong>
                  </div>

                  <div style="display: flex; gap: 15px; margin-top: 10px;">
                      <a href="#how-it-works" class="btn btn-primary" style="background: white; color: var(--brand-imperial); border: none; text-decoration: none;">See How It Works</a>
                  </div>
              </div>
          </div>
      </div>

      <div class="slider-dots">
        <div class="dot active" id="dot_1"></div>
        <div class="dot" id="dot_2"></div>
      </div>
    </section>

    <section class="section-padding features">
        <div class="container">
            <div class="section-header">
                <h2>Unified Financial Infrastructure</h2>
                <p>Orchestrate complex capital flows with programmable logic. Replace disconnected spreadsheets/systems and static banking portals with an automated financial operating system.</p>
            </div>

            <div class="grid-3">
                <div class="card">
                    <span class="card-tag">Government Construction</span>
                    <div class="icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path    d="M2 22h20"></path><path d="M4 22V9l8-5 8 5v13"></path><path d="M12 4v18"></path><path d="M8 10v12"></path><path d="M16 10v12"></path></svg>
                    </div>             
                    <h3>Job-Costed Financial Logic</h3>
                    <p>Stop fund commingling by design. LusidPay’s automated logic tags every invoice to specific Govt. Project IDs, enforcing rules that ensure capital is released strictly for materials, blocking overhead leakage programmatically.</p>
                </div>

                <div class="card">
                    <span class="card-tag">Compliance Core</span>
                    <div class="icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></svg>
                    </div>
                    <h3>Entity Telemetry Protocol</h3>
                    <p>Leverage our proprietary verification engine to synchronize multi-jurisdictional entity data. We utilize a decentralized consensus model to validate certification requirements against federal frameworks, ensuring immutable compliance readiness.</p>
                </div>

                <div class="card">
                    <span class="card-tag">Global Trade & Logistics</span>
                    <div class="icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                    </div>
                    <h3>Global Supply Chain Sync</h3>
                    <p>Unified infrastructure for Importers and Freight Forwarders. Manage multi-currency invoices and settle international supplier accounts instantly at wholesale conversion rates, integrating logistics data directly into the project budget.</p>
                </div>
            </div>
        </div>
    </section>



  <section class="section alt" id="manage-cash">
    <div class="section-title" style="margin-top:80px">Manage your cash inflows & outflows</div>       
    <center><p>One platform fully integrated to provide advanced money movement options and access to working capital.</p></center>
    <div class="cash-features-row">
      <div class="cash-feature">
        <span class="icon">💸</span>
        <h3>Accounts Payable</h3>
        <p>Simplify your vendor payments globally with our Accounts Payable solution. Make payments in over 38 currencies across 180 countries, automate recurring payments, and implement custom approval workflows for enhanced control.</p>
        <ul>
          <li>Global payment capabilities</li>
          <li>Custom approval workflows</li>
          <li>Multiple payment speed options</li>
          <li>Recurring payment automation</li>
        </ul>
        <a class="learn-more" href="/accounts-payable">Learn more</a>
      </div>
      <div class="cash-feature">
        <span class="icon">📥</span>
        <h3>Accounts Receivable</h3>
        <p>Optimize your cash flow by streamlining your payment collection process. Receive payments from customers using simple payment links that can be embedded in invoices or sent via email and mobile messages.</p>
        <ul>
          <li>Global payment acceptance</li>
          <li>Easy payment links</li>
          <li>Invoice tracking and reminders</li>
          <li>Multi-currency support</li>
        </ul>
        <a class="learn-more" href="/accounts-receivable">Learn more</a>
      </div>
    </div>
  </section>` }} />

  <section class="international-section" id="international-payments">
    <div class="international-bg"></div>
    <div class="international-content"  style={{ marginTop: '40px' }}>
      <h2 class="international-title">Pay Your Vendors Wherever They Are</h2>
      <p class="international-subtitle">
        Send payments to vendors around the world—in their preferred currency. LusidPay lets you pay all business expenses, domestic and international, from one place.
      </p>

      <div style={{
        background: '#fff',
        borderRadius: '24px',
        boxShadow: '0 2px 24px rgba(10,102,194,0.10)',
        padding: '24px 20px',
        maxWidth: '700px',
        width: '100%',
        margin: '0 auto 44px auto'
      }}>
        {/* <form onSubmit={} autoComplete="off"> */}
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            gap: '28px',
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row'
          }}>
            {/* USD Input Block */}
            <div style={{
              // flex: '1 1 45%',
              display: 'flex', 
              flexDirection: 'column',
              background: '#f8fafc',
              borderRadius: '14px',
              padding: '16px 14px',
              minWidth: window.innerWidth <= 768 ? '100%' : '180px',
              maxWidth: window.innerWidth <= 768 ? '100%' : '260px'
            }}>
              <label style={{
                fontSize: '1em',
                fontWeight: 600,
                color: '#253f83',
                marginBottom: '6px'
              }}>
                You pay
              </label>
              <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: "15px" }}>
                <span style={{ fontSize: '1.25em', color: '#253f83', fontWeight: 800 }}>$</span>
                <input
                  type="text"
                  value={usdAmount || ''}
                  onChange={(e) => {
                    setFixedSide("sell");
                    const formattedValue = formatNumber(e.target.value);
                    setUsdAmount(formattedValue);
                    setConvertedAmount("");
                  }}
                  onKeyDown={(evt) => {
                    // Allow: backspace, delete, tab, escape, enter, decimal point, numbers
                    if (!/[\d.\b]/.test(evt.key) && 
                        !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(evt.key)) {
                      evt.preventDefault();
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    fontSize: '1.1em',
                    fontWeight: 600,
                    border: '1.5px solid #dce6f1',
                    borderRadius: '8px',
                    background: '#fff',
                    color: '#38434f',
                    outline: 'none',
                    textAlign: 'right',
                  }}
                />
                <div>
                  <img src="https://flagcdn.com/us.svg" alt="US Flag" width="32" height="24" />
                </div>
              </div>
              <div style={{
                  marginTop: '8px',
                  fontSize: '1em',
                  color: '#56687a',
                  fontWeight: 600
                }}>
                  US Dollar (USD)
                </div>
            </div>

            <div style={{
              fontSize: '2em',
              color: '#253f83',
              fontWeight: 'bold',
              margin: window.innerWidth <= 768 ? '0' : '0 10px 14px',
              alignSelf: 'center',
              transform: window.innerWidth <= 768 ? 'rotate(90deg)' : 'none'
            }}>
              →
            </div>

            {/* Target Currency Block */}
            <div style={{
              display: 'flex', 
              flexDirection: 'column',
              background: '#f8fafc',
              borderRadius: '14px',
              padding: '16px 14px',
              minWidth: window.innerWidth <= 768 ? '100%' : '180px',
              maxWidth: window.innerWidth <= 768 ? '100%' : '260px'
            }}>
              <label style={{
                fontSize: '1em',
                fontWeight: 600,
                color: '#253f83',
                marginBottom: '6px'
              }}>
                Vendor receives
              </label>
              <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: "15px" }}>
                <span style={{ fontSize: '1.25em', color: '#253f83', fontWeight: 800 }}>
                  {currencyData[selectedCurrency]?.symbol}
                </span>
                <input
                  type="text"
                  value={convertedAmount || ''}
                  onChange={(e) => {
                    setFixedSide("buy");
                    setUsdAmount("");
                    const formattedValue = formatNumber(e.target.value);
                    setConvertedAmount(formattedValue);
                  }}
                  onKeyDown={(evt) => {
                    // Allow: backspace, delete, tab, escape, enter, decimal point, numbers
                    if (!/[\d.\b]/.test(evt.key) && 
                        !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(evt.key)) {
                      evt.preventDefault();
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    fontSize: '1.1em',
                    fontWeight: 600,
                    border: '1.5px solid #dce6f1',
                    borderRadius: '8px',
                    background: '#fff',
                    color: '#38434f',
                    outline: 'none',
                    textAlign: 'right',
                    // Add these styles to remove arrows
                    WebkitAppearance: 'none',
                    MozAppearance: 'textfield',
                    '&::-webkit-outer-spin-button': {
                      WebkitAppearance: 'none',
                      margin: 0,
                    },
                    '&::-webkit-inner-spin-button': {
                      WebkitAppearance: 'none', 
                      margin: 0,
                    }
                  }}
                />
                <div>
                  <img 
                    src={currencyData[selectedCurrency]?.flag} 
                    alt={`${selectedCurrency} Flag`} 
                    width="32" 
                    height="24"
                  />
                </div>
              </div>
              <select
                value={selectedCurrency}
                onChange={handleCurrencyChange}
                style={{
                  marginTop: '5px',
                  fontSize: '0.98em',
                  color: '#56687a',
                  fontWeight: 600,
                  width: '100%',
                  padding: '4px',
                  border: '1px solid #dce6f1',
                  borderRadius: '4px'
                }}
              >
                <option value="EUR" selected>Euro (EUR)</option>
                <option value="AUD">Australian Dollar (AUD)</option>
                <option value="BHD">Bahrain Dinar (BHD)</option>
                <option value="CAD">Canadian Dollar (CAD)</option>
                <option value="CNY">Chinese Yuan (CNY)</option>
                <option value="CZK">Czech Koruna (CZK)</option>
                <option value="DKK">Danish Krone (DKK)</option>
                <option value="HKD">Hong Kong Dollar (HKD)</option>
                <option value="HUF">Hungarian Forint (HUF)</option>
                <option value="INR">Indian Rupee (INR)</option>
                <option value="IDR">Indonesian Rupiah (IDR)</option>
                <option value="ILS">Israeli Shekel (ILS)</option>
                <option value="JPY">Japanese Yen (JPY)</option>
                <option value="KES">Kenyan Shilling (KES)</option>
                <option value="KWD">Kuwait Dinar (KWD)</option>
                <option value="MYR">Malaysian Ringgit (MYR)</option>
                <option value="MXN">Mexican Peso (MXN)</option>
                <option value="NZD">New Zealand Dollar (NZD)</option>
                <option value="NOK">Norwegian Krone (NOK)</option>
                <option value="OMR">Omani Rial (OMR)</option>
                <option value="PHP">Philippine Peso (PHP)</option>
                <option value="PLN">Polish Zloty (PLN)</option>
                <option value="QAR">Qatar Rial (QAR)</option>
                <option value="RON">Romanian Leu (RON)</option>
                <option value="SAR">Saudi Riyal (SAR)</option>
                <option value="SGD">Singapore Dollar (SGD)</option>
                <option value="ZAR">South African Rand (ZAR)</option>
                <option value="SEK">Swedish Krona (SEK)</option>
                <option value="CHF">Swiss franc (CHF)</option>
                <option value="THB">Thai Baht (THB)</option>
                <option value="TRY">Turkish Lira (TRY)</option>
                <option value="UGX">Ugandan Shilling (UGX)</option>
                <option value="GBP">UK Sterling (GBP)</option>
                <option value="AED">UAE Dirham (AED)</option>
              </select>
            </div>
          </div>

          <div style={{
            // display: 'flex',
            // justifyContent: 'space-between',
            // alignItems: 'center',
            // marginTop: '14px',
            // gap: '10px'

            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            marginTop: '24px',
            gap: '28px',
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row'
          }}>
            <span style={{ fontSize: '1em', color: '#38434f', fontWeight: 500 }}>
              {
                initialRateFetching
                ?
                <Skeleton
                  variant="text"
                  width={"260px"}
                  height={"26px"}
                  />
                :
                  conversionError === ""
                  ?
                  <div
                    className='flexCenter_Row'>
                    {"Current rate: 1 USD = "}&nbsp;
                    {
                      <>
                        {initialRate} {selectedCurrency}
                      </>
                    }            
                  </div>
                  :
                  <div
                    className='flexCenter_Row'>
                    <span style={{ fontSize: '0.9em', color: '#38434f', fontWeight: 500 }}>
                      {conversionError}
                    </span>
                  </div>
              } 
            </span>
            <button
              type="submit"
              disabled={rateFetching}
              onClick={handleConversion}
              style={{
                minWidth: '120px',
                maxHeight: '40px',
                background: '#253f83',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                padding: '10px 26px',
                fontSize: '1.08em',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              {
                rateFetching
                ?
                <CircularProgress 
                  size={20}
                  thickness={5}
                  sx={{ color: "white", borderWidth: "9px" }}/>
                :
                "Convert"
              }
            </button>
          </div>

          <div style={{
            marginTop: '10px',
            fontSize: '0.69em',
            color: '#56687a',
            textAlign: 'left'
          }}>
            Exchange rates are subject to frequent fluctuations.
          </div>
        {/* </form> */}
      </div>

      <div class="international-steps">
        <div class="international-step">
          <div class="international-icon" style={{ background: "#253f831a" }}>
            <img src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f4cb.svg" alt="Bill" width="38" height="38" />
          </div>
          <div class="international-step-title">Add Your Bill</div>
          <div class="international-step-desc">Upload or enter your bill, then select your international vendor to pay.</div>
        </div>
        <div class="international-step">
          <div class="international-icon" style={{ background: "#fbbd041a" }}>
            <img src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f4b1.svg" alt="Currency" width="38px" height="38px" />
          </div>
          <div class="international-step-title">Choose Currency & Method</div>
          <div class="international-step-desc">Select your vendor’s currency and see the converted amount and competitive rate. Pay by bank transfer or card.</div>
        </div>
        <div class="international-step">
          <div class="international-icon" style={{ background: "#00c49a1a" }}>
            <img src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f4e6.svg" alt="Bank" width="38" height="38" />
          </div>
          <div class="international-step-title">Send & Track</div>
          <div class="international-step-desc">Vendor receives payment fast, directly to their bank, in their local currency. Track every step from your LusidPay dashboard.</div>
        </div>
      </div>
      <div class="international-benefits">
        <div class="international-benefit">
          <span class="benefit-icon" style={{ background: "#253f831a" }}>💱</span>
          Competitive exchange rates
        </div>
        <div class="international-benefit">
          <span class="benefit-icon" style={{ background: "#fbbd041a" }}>🌍</span>
          Pay in 35 currencies, 180+ countries
        </div>
        <div class="international-benefit">
          <span class="benefit-icon" style={{ background: "#00c49a1a" }}>⚡</span>
          Fast, secure delivery
        </div>
        <div class="international-benefit">
          <span class="benefit-icon" style={{ background: "#56687a1a" }}>🧾</span>
          Full transparency—no hidden fees
        </div>
      </div>
    </div>
  </section>

  {/* // <li>Checks can optionally be mailed for you, printed on high-security stock</li> */}
  <div dangerouslySetInnerHTML={{ __html: `

  <section class="cta-section" id="echecks" style="max-width: 1100px; margin: 40px auto 0px auto;">
    <h2>Generate eChecks Instantly — No Special Paper Needed</h2>
    <p style="padding: 0 20px; margin-bottom: 20px;">
      Send secure business payments by check—without the hassle, cost, or delay of physical checkbooks. With Lusid's eCheck capability, payees receive a legally valid check by email. They can print and deposit it just like a normal check, or use it with their mobile banking app. No special paper or ink required.
    </p>
    <ul style="font-size:1.07rem; color:#56687a; margin-bottom: 40px; list-style-position: inside; list-style-type: none;">
      <li>Send checks as easily as sending an email</li>
      <li>Deliver a digital PDF—ready to print and deposit anywhere in the US</li>
      <li>No need for pre-printed stock—plain paper works (Check 21 compliant)</li>
      <li>Easy integration with accounting systems and bulk check runs</li>
      <li>Save money, time, and reduce payment fraud risk</li>
    </ul>
    <a href="/checks">
      <button class="cta-main">Learn more about eChecks</button>
    </a>
  </section>

  <section class="section" id="trust">
    <div class="section-title">Why LusidPay?</div>
    <div class="trust-row">
      <div class="trust-block">Reliable, secure, and scalable platform</div>
      <div class="trust-block">Modern architecture for peace of mind</div>
      <div class="trust-block">Committed to your success</div>
    </div>
    <div class="security-note">
      Bank-grade encryption &nbsp;|&nbsp; Multi-factor authentication &nbsp;|&nbsp; Regular third-party audits
    </div>
  </section>

  <section class="section" id="industries">
    <div class="section-title">Industries We Serve</div>
    <div class="industry-tabs-row">
      <button class="industry-tab">Construction</button>
      <button class="industry-tab">Freights/Logistics</button>
      <button class="industry-tab">Global Trade</button>
    </div>
    <div class="industry-desc">
      Explore tailored solutions for your industry with Lusid's customizable platform.
    </div>
  </section>

  <section class="section" id="how-it-works">
    <div class="section-title">How It Works</div>
    <div class="how-works-row">
      <div class="how-step">
        <h4>1. Connect your accounting system</h4>
        <p>QuickBooks Desktop, QuickBooks Online and Xero.</p>
      </div>
      <div class="how-step">
        <h4>2. AI maps your vendors, items, and transactions</h4>
        <p>Automate payments, reconciliation, and reporting.</p>
      </div>
      <div class="how-step">
        <h4>3. Streamline your tasks, and workflow</h4>
        <p>Save time and reduce errors with intelligent automation.</p>
      </div>
    </div>
  </section>

  <section class="testimonials-section" id="testimonials">
    <h2>What Our Clients Say</h2>
    <div class="testimonial-block">
      “LusidPay replaced the entire paper check chase with a single click. We now fund materials instantly without ever worrying if the supplier actually got paid.”
      <span class="testimonial-author">– Controller, Commercial General Contractor</span>
    </div>
    <div class="testimonial-block">
      “The industry-specific modules are exactly what we needed.”
      <span class="testimonial-author">– Finance Director, Logistics Company</span>
    </div>
  </section>

  <section class="cta-section">
    <h2>Ready to transform your finance operations?</h2>
    <a href="/contact-us">
      <button class="cta-main">Contact Sales</button>
    </a>
  </section>

  <script>
    // Currency data for dropdown: code, symbol, flag URL
    const currencyData = {
      EUR: {symbol: "€", flag: "https://flagcdn.com/eu.svg"},
      AUD: {symbol: "A$", flag: "https://flagcdn.com/au.svg"},
      BHD: {symbol: "ب.د", flag: "https://flagcdn.com/bh.svg"},
      CAD: {symbol: "C$", flag: "https://flagcdn.com/ca.svg"},
      CNY: {symbol: "¥", flag: "https://flagcdn.com/cn.svg"},
      CZK: {symbol: "Kč", flag: "https://flagcdn.com/cz.svg"},
      DKK: {symbol: "kr", flag: "https://flagcdn.com/dk.svg"},
      HKD: {symbol: "HK$", flag: "https://flagcdn.com/hk.svg"},
      HUF: {symbol: "Ft", flag: "https://flagcdn.com/hu.svg"},
      INR: {symbol: "₹", flag: "https://flagcdn.com/in.svg"},
      IDR: {symbol: "Rp", flag: "https://flagcdn.com/id.svg"},
      ILS: {symbol: "₪", flag: "https://flagcdn.com/il.svg"},
      JPY: {symbol: "¥", flag: "https://flagcdn.com/jp.svg"},
      KES: {symbol: "KSh", flag: "https://flagcdn.com/ke.svg"},
      KWD: {symbol: "د.ك", flag: "https://flagcdn.com/kw.svg"},
      MYR: {symbol: "RM", flag: "https://flagcdn.com/my.svg"},
      MXN: {symbol: "Mex$", flag: "https://flagcdn.com/mx.svg"},
      NZD: {symbol: "NZ$", flag: "https://flagcdn.com/nz.svg"},
      NOK: {symbol: "kr", flag: "https://flagcdn.com/no.svg"},
      OMR: {symbol: "ر.ع.", flag: "https://flagcdn.com/om.svg"},
      PHP: {symbol: "₱", flag: "https://flagcdn.com/ph.svg"},
      PLN: {symbol: "zł", flag: "https://flagcdn.com/pl.svg"},
      QAR: {symbol: "ر.ق", flag: "https://flagcdn.com/qa.svg"},
      RON: {symbol: "lei", flag: "https://flagcdn.com/ro.svg"},
      SAR: {symbol: "ر.س", flag: "https://flagcdn.com/sa.svg"},
      SGD: {symbol: "S$", flag: "https://flagcdn.com/sg.svg"},
      ZAR: {symbol: "R", flag: "https://flagcdn.com/za.svg"},
      SEK: {symbol: "kr", flag: "https://flagcdn.com/se.svg"},
      CHF: {symbol: "Fr", flag: "https://flagcdn.com/ch.svg"},
      THB: {symbol: "฿", flag: "https://flagcdn.com/th.svg"},
      TRY: {symbol: "₺", flag: "https://flagcdn.com/tr.svg"},
      UGX: {symbol: "USh", flag: "https://flagcdn.com/ug.svg"},
      GBP: {symbol: "£", flag: "https://flagcdn.com/gb.svg"},
      AED: {symbol: "د.إ", flag: "https://flagcdn.com/ae.svg"}
    };

    // Set up calculator logic and flag/symbol update
    const rightCurrency = document.getElementById('rightCurrency');
    const rightFlag = document.getElementById('rightFlag').querySelector('img');
    const rightSymbol = document.getElementById('rightSymbol');
    const rightAmount = document.getElementById('rightAmount');
    const usdAmount = document.getElementById('usdAmount');
    const lusidExchangeCalc = document.getElementById('lusidExchangeCalc');
    const exchangeRateText = document.getElementById('exchangeRateText');

    // Example rates (USD to selected currency). You can replace with live rates.
    const rates = {
      EUR: 0.8698, AUD: 1.48, BHD: 0.377, CAD: 1.36, CNY: 7.23, CZK: 22.6, DKK: 6.85,
      HKD: 7.83, HUF: 348, INR: 83.2, IDR: 16200, ILS: 3.65, JPY: 156.2, KES: 131.2,
      KWD: 0.307, MYR: 4.7, MXN: 16.8, NZD: 1.62, NOK: 10.7, OMR: 0.385, PHP: 57.2,
      PLN: 4.05, QAR: 3.64, RON: 4.32, SAR: 3.75, SGD: 1.35, ZAR: 18.1, SEK: 10.5,
      CHF: 0.91, THB: 36.1, TRY: 32.5, UGX: 3840, GBP: 0.79, AED: 3.67
    };

    function updateRightFlagAndSymbol() {
      const code = rightCurrency.value;
      rightFlag.src = currencyData[code].flag;
      rightFlag.alt = code + " Flag";
      rightSymbol.textContent = currencyData[code].symbol;
      rightAmount.value = '';
      exchangeRateText.textContent = "Current rate: 1 USD = " + {rates[code]} + {code}"
    }

    rightCurrency.addEventListener('change', updateRightFlagAndSymbol);

    lusidExchangeCalc.addEventListener('submit', function(e) {
      e.preventDefault();
      const code = rightCurrency.value;
      const rate = rates[code];
      const usd = parseFloat(usdAmount.value) || 0;
      let converted = 0;
      if (usd > 0 && rate > 0) {
        converted = usd * rate;
        rightAmount.value = converted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
      }
    });

    // Initialize on page load
    updateRightFlagAndSymbol();
  </script>
</body>
</html>` }} />
</>
  )
}

export default HomePage;